var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Profile / Active") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "App",
    stroke: "none",
    strokeWidth: 1,
    fill: "#fff",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-451.000000, -1301.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Profile-/-Active",
    transform: "translate(451.000000, 1301.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("g", {
    id: "User",
    mask: "url(#mask-2)",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.000000, 3.000000)",
    id: "Path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.00000346,8 C9.2087,8 11.0000035,6.20869 11.0000035,4 C11.0000035,1.79043 9.2087,0 7.00000346,0 C4.79133,0 3.00000346,1.79043 3.00000346,4 C2.99208,6.20075 4.77103,7.9921 6.9718,8 L7.00000346,8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,18 C3.22483,18 0,17.4466 0,15.2309 C0,13.0152 3.20404,11 7,11 C10.7752,11 14,12.996 14,15.2107 C14,17.4255 10.796,18 7,18 Z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.2fe6854d0b0eedbba3466ffbeb90e290.svg";
export { ForwardRef as ReactComponent };